<template>
  <el-dialog
    title="设置评估成绩"
    :visible.sync="setScore"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="650px"
    center>
    <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="100px">
      <el-form-item label="得分" prop="score">
        <el-select v-model="scoreForm.score" placeholder="请选择得分" style="width: 100%">
          <el-option
            v-for="item in scoreList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="扣分原因" prop="remark" v-if="scoreForm.score !== total_points && scoreForm.score !== -1">
        <el-input type="textarea" v-model="scoreForm.remark" placeholder="请输入扣分原因"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <div class="flex align-center justify-around margin-top">
          <el-button class="padding-lr-xl" @click="resetForm('scoreForm')">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('scoreForm')">提交</el-button>
        </div>
      </el-form-item>
    </el-form>


  </el-dialog>
</template>

<script>


import {saveEditScore} from "@/api/admin";

export default {
  name: "setScore",
  props: {
    setScore: {
      type: Boolean,
    },
    setItem: {
      type: Object,
    },
  },
  data() {
    return {
      scoreList: [],
      total_points: '',
      scoreForm: {
        score: '',
        remark: ''
      },
      rules: {
        score: [{required: true, message: '请选择得分', trigger: 'change'}],
        remark: [{required: true, message: '请输入扣分原因', trigger: 'blur'}],
      },

    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    if (this.setItem) {
      this.setItem.json.split(',').map(item => {
        this.scoreList.push({
          value: Number(item),
          label: Number(item) === -1 ? '无涉指标' : item + '分'
        })
      })
      this.total_points = this.setItem.total_points
      this.score = this.setItem.score
      this.remark = this.setItem.remark
    }
  },
  methods: {
    resetForm() {
      this.$emit('cancelDialog', false)
    },
    async submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },

    async submitData(formName) {
      let _state = await saveEditScore(
        this.setItem.id,
        this.scoreForm.score,
        (this.scoreForm.score !== this.total_points && this.scoreForm.score !== -1)?this.scoreForm.remark:'',
      );
      if(_state.status === 200){
        this.$message.success(_state.info);
        this.$refs[formName].resetFields();
        this.$emit("cancelDialog", true);
      }

    }
  },
  watch: {
    setItem() {
      if (this.setItem) {
        this.setItem.json.split(',').map(item => {
          this.scoreList.push({
            value: Number(item),
            label: Number(item) === -1 ? '无涉指标' : item + '分'
          })
        })
        this.total_points = this.setItem.total_points
        this.scoreForm.score = this.setItem.score
        this.scoreForm.remark = this.setItem.remark
      } else {
        this.scoreList = []
        this.total_points = ''
        this.scoreForm.score = ''
        this.scoreForm.remark = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
